<template>
  <WizardBox title="New Automation Rule">
    <template v-slot:tools>
      
    </template>
    <template v-slot:content>
      <FormGroup v-bind:form="ruleForm">
        <FormWizard ref="ruleWizard" :form="ruleForm" :submitting="submitting" v-bind:tabList="tabList" @finished="handleSubmit">
          <template v-slot:content>
            
            <FormWizardStep index="1" v-bind:active="true">
              <FormRow label="Name">
                <FormInputText placeholder="Name" v-model="autoRule.name" field="name" />
              </FormRow>
              <FormRow label="Description">
                <FormInputText placeholder="Description" v-model="autoRule.description" field="description" />                  
              </FormRow>
            </FormWizardStep>

            <FormWizardStep index="2">
              <AutomationRuleTree :editing="true" v-model="autoRule.autoRuleComponents" />
            </FormWizardStep>
          </template>
        </FormWizard>
      </FormGroup>
    </template>
  </WizardBox>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import form from '@/mixins/form'
import detectUnload from '@/mixins/detectUnload'
import AutomationMixin from '@/modules/automations/mixins/automations'

import WizardBox from '@/components/wizardBox'

import AutomationRuleTree from '@/modules/automations/components/automationRuleTree'

export default {
  name: 'AutomationRuleNew',
  mixins: [form, detectUnload, AutomationMixin],
  components: {
    WizardBox,
    AutomationRuleTree
  },
  data() {
    return {
      ruleForm: {},
      submitting: false,
      autoRule: {
        name: '',
        description: '',
        autoRuleComponents: []
      },
      tabList: [
        { title: 'Details' },
        { title: 'Components' }
      ],
      isRuleEdited: true,
    }
  },
  beforeRouteLeave (to, from, next) {
    if(!this.$data.isRuleEdited)
      return next(true)
    
    this.confirmMessage(`Cancel Automation Rule?`, `You have unsaved changes with the new automation rule, are you sure you want to leave?`)
    .then(success => {
      next(success)
    })
    .catch(function () {
      next(false)
    })
  },
  onBeforeUnload: function(event) {
    // Ignore for local dev
    if(this.$glass.isLocalSite)
      return null
    if(!this.$data.isRuleEdited)
      return null

    var confirmationMessage = `You have unsaved changes with this new automation rule. Are you sure you want to exit?`

    event.returnValue = confirmationMessage
    return confirmationMessage
  },
  mounted() {
    // Check if we're copying the data from another automation rule
    if(this.$route.params.copyFromRule) {
      this.copySourceAutomationRule(this.$route.params.sourceAutoRuleId)
    }
  },
  methods: {
    handleSubmit() {
      this.submitting = true

      // Build into nested structure for creating/updating with 'children' field
      var automationRuleData = _.cloneDeep(this.autoRule)
      automationRuleData.autoRuleComponents = this.prepareComponentListForUpdate(this.autoRule.autoRuleComponents)

      this.$apiService.automationService.createAutomationRule(automationRuleData)
      .then(response => {
        this.$data.isRuleEdited = false

        this.successToast('Automation Rule Created')
        this.$router.push(`/automations/rules/${response.data.id}`)
      })
      .catch(err => {
        this.$data.ruleForm = this.processFormResponse(err)
        this.$refs.ruleWizard.displayErrors()
      })
      .finally(() => {
        this.submitting = false
      })
    },
    copySourceAutomationRule(sourceAutoRuleId) {
      this.$nextTick(() => {
        this.displayProcessingDialog({
          title: 'Copying Automation Rule',
          message: 'Loading rule',
          icon: 'fa-copy',
          onBeforeOpen: (instance) => {

            // Download an existing rule & copy in the data
            this.$apiService.automationService.getAutomationRule(sourceAutoRuleId)
            .then(async (response) => {
              this.autoRule = _.cloneDeep(response.data)

              // Clear some data
              this.autoRule.autoRuleComponents.forEach(ruleComp => {
                ruleComp.isNewComponent = true
              })
            })
            .catch(err => {
              this.displayNetworkError(err, 'Error Copying Automation rule', 'Could not copy the rule')
            })
            .finally(() => {
              instance.hide()
            })
          }
        })
      })
    }
  }
}
</script>
